// eslint-disable-next-line require-jsdoc
// eslint-disable-next-line require-jsdoc
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import '../../../stylesheets/productlist.scss';
import { Modal, ModalContent } from '@ids/modal-dialog';

/*
 * Responsive grid supports mobile or xs mode at 480px.
 * But according to specs it needs to be 375px.
 *Include the custom built css for mobile everytime the responsivegrid is included.
 */
import '@ids-alpha/responsive-grid';
import '../../../stylesheets/responsiveGridStyles.scss';
import '../../../stylesheets/main.scss';
import '../../../stylesheets/product.scss';
import { ProductPricingInformation } from './ProductPricingInformation';
import { OftenBoughtTogetherPage } from './OftenBoughtTogetherPage';
import WarningImage from '../../../assets/images/warning_logos.gif';

import CheckLockImage from '../../../assets/images/IM/Checks/checklock_button.png';
import { CheckFraud } from '../Common/CheckFraud';
import { CheckFacts } from '../Common/CheckFacts';
import { getSecurePlusProductFeatures, productListFetch } from '../../services/productDataService';
import {
  getCurrentFisicalYear,
  sortByQuantityAsc,
  isStockChangeTextAvil,
  createOutOfStockList,
  isProductOutOfStock,
  getImageSrc,
} from '../Util/CommonUtils';
import Loader from '../Common/Loader';
import { ProductFaq } from './ProductFaq';
import IRSTaxModal from '../TaxProducts/IRSTaxModal';

export const SpinnerWrapper = styled.div`
    left: 50%;
    top: 20%;
    transform: translate(-50%, -50%);
    position: absolute;
}`;

// eslint-disable-next-line require-jsdoc
const ProductPage = (props) => {
  const { pageData } = props;
  const [pricing, setPricing] = useState([]);
  const [fetchError, setFetchError] = useState(false);
  const [openModal, setOpenModel] = useState(false);
  const [isCheckLock, setCheckLock] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [modalSize, setModalSize] = useState('medium');
  const [modalContentAlignment, setModalContentAlignment] = useState('center');
  const [loading, setLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const boughtTogether = pageData.Department.BroughtTogether;
  const [itemsList, setItemsList] = useState([]);
  const [outOfStockItems, setoutOfStockItems] = useState([]);
  const [outOfStockPfid, setOutOfStockPfid] = useState({});
  const [efileModal, setEfileModal] = useState(false);
  const getImage = (imageLocation) => {
    switch (pageData.Department.PFID) {
      case 'value':
        break;

      default:
        return pageData.Department.ImageIsUrl ? getImageSrc(imageLocation) : imageLocation;
    }
  };
  const [image, setImage] = useState(getImage(pageData.Department.Image));
  const [imageLg, setImageLg] = useState(getImage(pageData.Department.ImageLg));
  const [imageOpt, setImageOpt] = useState(getImage(pageData.Department.ImageSrcOptimized));
  const [imageOptLg, setImageOptLg] = useState(getImage(pageData.Department.ImageSrcOptimizedLg));


  // eslint-disable-next-line require-jsdoc
  const loadData = (pricingData) => {
    setPricing(pricingData);
    setLoading(false);
  };

  const getDistinctItemNumbers = (productList) => {
    let distinctList = [];
    if (productList && productList.length > 0) {
      distinctList = [...new Set(productList[0].map((prdct) => prdct.Sku.split('-')[0]))];
    }
    setItemsList(distinctList);
  };

  const closeEfileModal = () => {
    setEfileModal(false);
  };
  const openEfileModal = () => {
    setEfileModal(true);
  };
  useEffect(() => {
    props.logToIMWebLogger(
      'info',
      `ProductPage: ${pageData.Department.DeptName} page load completed`,
    );

    // eslint-disable-next-line require-jsdoc
    const getProductInfo = async (payload) => {
      productListFetch(payload)
        .then((json) => {
          loadData(json);
            const outOfStockList = createOutOfStockList(json);
            setoutOfStockItems(outOfStockList);
            const pfidProductStatus = isProductOutOfStock(
              {
                pfid: pageData.Department.PFID,
                sku: null,
              },
              outOfStockList,
            );
            setOutOfStockPfid(pfidProductStatus);
          props.logToIMWebLogger(
            'info',
            `ProductPage: productListFetch completed successfully for ${pageData.Department.DeptName}.`,
          );
          getDistinctItemNumbers(json);
          setLoading(false);
        })
        .catch((err) => {
          setFetchError(true);
          setLoading(false);
          props.logToIMWebLogger(
            'error',
            `ProductPage: productListFetch failed for ${pageData.Department.DeptName} page. Error: ${err}`,
          );

          // Send it to analytics
          props.logToAnalytics({
            eventList: 'error',
            error: `ProductPage: productListFetch failed for ${pageData.Department.DeptName} page. Error: ${err}`,
          });
        });
    };

    if (pageData.Department.FetchPricing) {
      getProductInfo(pageData.Department.RequestBody);
    } else {
      setLoading(false);
    }

    // Send it to analytics
    const p = [];
    if (pageData.Department.RequestBody) {
      pageData.Department.RequestBody.forEach((e) => {
        p.push([e]);
      });

      props.logToAnalytics({
        aryProducts: p,
        eventList: 'product_view',
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPrices = (pfid, sku = null) => {
    let returnVal = [];
    const pr = pricing.find((x) => x.find((y) => y.PfID === pfid));

    if (!pr) {
      return returnVal;
    }

    if (sku) {
      returnVal = pr.filter((x) => x.Sku.indexOf(sku) === 0);
    } else {
      returnVal = pr;
    }

    return returnVal.sort(sortByQuantityAsc);
  };

  const handleModalOpen = () => {
    setOpenModel(true);
  };

  const openImageInModal = (imgSrc, OptimizedImg) => {
    const content = (
      <div className="img-wrapper">
        {OptimizedImg ? (
          <picture>
            <source
              style={{ maxWidth: '500px' }}
              alt="..."
              srcset={getImageSrc(OptimizedImg)}
              height={
                pageData.Department.ImageHeightLg ? pageData.Department.ImageHeightLg : 'auto'
              }
              width={pageData.Department.ImageWidthLg ? pageData.Department.ImageWidthLg : 'auto'}
            />
            <img
              style={{ maxWidth: '500px' }}
              alt="..."
              src={getImageSrc(imgSrc)}
              height={
                pageData.Department.ImageHeightLg ? pageData.Department.ImageHeightLg : 'auto'
              }
              width={pageData.Department.ImageWidthLg ? pageData.Department.ImageWidthLg : 'auto'}
            />
          </picture>
        ) : (
          <img
            style={{ maxWidth: '500px' }}
            alt="..."
            src={getImageSrc(imgSrc)}
            height={pageData.Department.ImageHeightLg ? pageData.Department.ImageHeightLg : 'auto'}
            width={pageData.Department.ImageWidthLg ? pageData.Department.ImageWidthLg : 'auto'}
          />
        )}
      </div>
    );

    setModalContentAlignment('center');
    setModalSize('medium');
    setModalContent(content);
    handleModalOpen();
  };

  const scrollModalContentBottom = () => {
    const element = document.getElementById('fraud-modal');
    element.scrollTop = element.scrollHeight;
  };

  const needsOverFlow = () => {
    const r = isCheckLock && window.innerWidth < 480;
    return r;
  };

  const openCheckFraudInModal = () => {
    const content = (
      <div
        style={{ overflowY: 'scroll', height: '70vh', scrollBehavior: 'smooth' }}
        id="fraud-modal"
      >
        <CheckFraud {...props} onTermsClicked={scrollModalContentBottom} />
      </div>
    );

    setCheckLock(true);
    setModalContentAlignment('left');
    setModalSize('large');
    setModalContent(content);
    handleModalOpen();
  };

  const openSecurityFeaturesInModal = (html) => {
    const content = html;
    setCheckLock(true);
    setModalContentAlignment('left');
    setModalSize('large');
    setModalContent(content);
    handleModalOpen();
  };

  const handleModalClose = () => {
    setOpenModel(false);
    setCheckLock(false);
    setModalContent(null);
    setModalSize('medium');
    setModalContentAlignment('center');
  };

  const onSecurityFeatureClicked = () => {
    setShowLoader(true);
    getSecurePlusProductFeatures()
      .then((res) => {
        setShowLoader(false);
        openSecurityFeaturesInModal(res);
        props.logToIMWebLogger(
          'info',
          `ProductPage: onSecurityFeatureClicked -> getSecurePlusProductFeatures successfully for ${pageData.Department.DeptName}.`,
        );
      })
      .catch((err) => {
        setShowLoader(true);
        const msg = `ProductPage: onSecurityFeatureClicked -> getSecurePlusProductFeatures failed for ${pageData.Department.DeptName} page. Error: ${err}`;
        props.logToIMWebLogger('error', msg);

        props.logToAnalytics({
          eventList: 'error',
          error: msg,
        });
      });
  };

  const prodPriceInfoCallBack = (response) => {
    switch (pageData.Department.PFID) {
      case 'PERF-01':
        if (response) {
          setImage(getImage(response.SmallImageUrl));
          setImageLg(getImage(response.LargeImageUrl));
          setImageOpt(getImage(response.SmallImageUrlOptimized));
          setImageOptLg(getImage(response.LargeImageUrlOptimizedLg));
        } else {
          setImage(getImage(pageData.Department.Image));
          setImageLg(getImage(pageData.Department.ImageLg));
          setImageOpt(getImage(pageData.Department.ImageSrcOptimized));
          setImageOptLg(getImage(pageData.Department.ImageSrcOptimizedLg));
        }
        break;

      case 'FOLDER-01':
      case 'FOLDER-02':
      case 'FOLDER-03':
      case 'FOLDER-04':
        if (response) {
          const coloredImages = pageData.Department.Images[response];
          if (coloredImages) {
            setImage(coloredImages.Small);
            setImageLg(coloredImages.Large);
          }
        }
        break;

      default:
        break;
    }
  };

  const getTitleName = (department) => {
    switch (department.PFID) {
      case 'TAX-01':
      case 'TAX-03':
      case 'TAX-04':
        return `${getCurrentFisicalYear()} ${department.DeptName}`;

      default:
        return department.DeptName;
    }
  };

  const getDescriptionExtras = () => {
    switch (pageData.Department.PFID) {
      case 'CHECK':
        return [
          <span>
            Offers advanced protection against check fraud with{' '}
            <span
              className="universal-link"
              style={{ cursor: 'pointer' }}
              onClick={onSecurityFeatureClicked}
            >
              23 additional security features
            </span>
            , including a heat sensitive icon that{' '}
            <span className="font-wgt-500">prevents photocopying</span>, a CheckLock™ Custom True
            Watermark that{' '}
            <span className="font-wgt-500">protects against forgery and counterfeiting</span>, and
            our exclusive security coating that{' '}
            <span className="font-wgt-500">blocks tampering</span> with your check info.
          </span>,
        ];

      default:
        return pageData.Department.ProductInformation.DescExtras;
    }
  };

  return (
    <div className="product-page-type1">
      <Loader show={showLoader} size={80} loadingText="Loading.." />
      <div className="container-center-lg">
        <div className="margin-main-section">
          <div className="row">
            <div className="prod-desc-spacing prod-desc-headers">
              <div
                className={`col-lg-12 col-sm-12 col-xs-12 ${
                  pageData.Department.DepSubHeader ? 'margin-bottom-5' : ''
                }`}
              >
                <h1>{getTitleName(pageData.Department)}</h1>
              </div>
              {pageData.Department.DepSubHeader && (
                <div className="col-lg-12 col-sm-12 col-xs-12">
                  <div className="department-sub-header font-wgt-600" style={{ marginBottom: 0 }}>
                    {pageData.Department.DepSubHeader}
                  </div>
                </div>
              )}
              {pageData.Department.DeptDesc && (
                <div className="col-lg-10 col-sm-12 col-xs-12">
                  <div className="department-desc margin-top-20 product-page-dept-dec">
                    {pageData.Department.DeptDesc}
                  </div>
                  {pageData.Department.DeptSubDesc && pageData.Department.LearnMore && (
                    <div className="department-desc margin-top-20 product-page-dept-dec">
                      <span className="irs-sub-desc">{pageData.Department.DeptSubDesc}</span>
                      <span
                        onClick={openEfileModal}
                        className="irs-learn-more"
                        style={{ cursor: 'pointer' }}
                      >
                        {pageData.Department.LearnMore}
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-sm-3 col-lg-3">
              <div
                data-wa-link="View Large Image"
                className="image-column"
                role="button"
                tabIndex={0}
                onClick={(e) =>
                  imageLg || imageOptLg ? openImageInModal(imageLg, imageOptLg) : e.preventDefault()
                }
                onKeyUp={(e) => {
                  (imageLg || imageOptLg) && e.key === 'Enter'
                    ? openImageInModal(imageLg, imageOptLg)
                    : e.preventDefault();
                }}
              >
                {pageData.Department.ImageSrcOptimized ? (
                  <picture>
                    <source
                      className="margin-bottom-20"
                      alt="..."
                      srcset={getImageSrc(imageOpt)}
                      height={
                        pageData.Department.ImageHeight ? pageData.Department.ImageHeight : 'auto'
                      }
                      width={
                        pageData.Department.ImageWidth ? pageData.Department.ImageWidth : 'auto'
                      }
                    />
                    <img
                      className="margin-bottom-20"
                      alt="..."
                      src={getImageSrc(image)}
                      height={
                        pageData.Department.ImageHeight ? pageData.Department.ImageHeight : 'auto'
                      }
                      width={
                        pageData.Department.ImageWidth ? pageData.Department.ImageWidth : 'auto'
                      }
                    />
                  </picture>
                ) : (
                  <img
                    className="margin-bottom-20"
                    alt="..."
                    src={getImageSrc(image)}
                    height={
                      pageData.Department.ImageHeight ? pageData.Department.ImageHeight : 'auto'
                    }
                    width={pageData.Department.ImageWidth ? pageData.Department.ImageWidth : 'auto'}
                  />
                )}
                {(imageOptLg || imageLg) && (
                  <p className="lnk-view-lg-img">
                    {imageOptLg ? 'View larger image' : 'View larger image'}
                  </p>
                )}
              </div>
              {pageData.Department.ImageText && (
                <p
                  className="p2-regular margin-bottom-20 margin-top-20 product-img-txt"
                  style={{ marginRight: '8rem' }}
                  data-ui-object="button"
                  data-refer-ui-access-point="product_page | view_larger"
                >
                  {pageData.Department.ImageText}
                </p>
              )}
            </div>
            <div className="col-xs-12 col-sm-6 col-lg-6">
              <div className="middle-content">
                <p className="margin-bottom-20 p2-regular">
                  {pageData.Department.ProductInformation.Desc}
                </p>

                {getDescriptionExtras() &&
                  getDescriptionExtras().map((d, key) => {
                    return (
                      // eslint-disable-next-line react/no-array-index-key
                      <p key={`KitContains-${key}`} className="p2-regular margin-bottom-10">
                        {d}
                      </p>
                    );
                  })}

                {pageData.Department.ProductInformation.DescPoints && (
                  <div className="margin-bottom-10">
                    {pageData.Department.ProductInformation.DescPoints.Header && (
                      <p className="p2-regular">
                        {pageData.Department.ProductInformation.DescPoints.Header}
                      </p>
                    )}

                    <ul style={{ paddingInlineStart: '20px' }}>
                      {pageData.Department.ProductInformation.DescPoints.List.map((d, key) => {
                        return (
                          <li
                            key={`KitContains-${key}`}
                            className="margin-bottom-10"
                            style={{ paddingLeft: '10px' }}
                          >
                            <p className="p2-regular">{d}</p>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}

                <div style={{ height: '10px' }} />

                {pageData.Department.ProductInformation.CheckLockProtection && (
                  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                  <img
                    onClick={openCheckFraudInModal}
                    onKeyUp={(e) => {
                      e.key === 'Enter' ? openCheckFraudInModal() : e.preventDefault();
                    }}
                    alt="..."
                    src={CheckLockImage}
                    tabIndex="0"
                    className="check-lock"
                  />
                )}

                {pageData.Department.ProductInformation.EachKitContains &&
                  pageData.Department.ProductInformation.EachKitContains.length > 0 && (
                    <div>
                      <p className="p2-regular margin-bottom-10">
                        {pageData.Department.PricingInformation &&
                        pageData.Department.PricingInformation.Type === 'BUNDLE'
                          ? 'This Value Pack contains:'
                          : 'Each kit contains:'}
                      </p>
                      <ul style={{ paddingInlineStart: '20px' }}>
                        {pageData.Department.ProductInformation.EachKitContains.map((c, key) => {
                          return (
                            // eslint-disable-next-line react/no-array-index-key
                            <li
                              key={`KitContains-${key}`}
                              className="margin-bottom-10"
                              style={{ paddingLeft: '10px' }}
                            >
                              <p className="p2-regular">{c}</p>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}

                <div style={{ height: '10px' }} />

                <div>
                  {(pageData.Department.ProductInformation.Specifications ||
                    (!!itemsList && itemsList.length >= 1)) && (
                    <p className="p2-regular margin-bottom-10 font-wgt-600">Specifications</p>
                  )}
                  <ul style={{ paddingInlineStart: '20px' }}>
                    {pageData.Department.ProductInformation.Specifications &&
                      pageData.Department.ProductInformation.Specifications.map((c, key) => {
                        return (
                          // eslint-disable-next-line react/no-array-index-key
                          <li key={`Specs-${key}`} className="padding-left-10">
                            <p className="p2-regular margin-bottom-10">{c}</p>
                          </li>
                        );
                      })}
                    {!!itemsList && itemsList.length >= 1 && (
                      <li className="margin-bottom-10 padding-left-10">
                        <p className="p2-regular margin-bottom-10">
                          Item numbers: {itemsList.join(', ')}
                        </p>
                      </li>
                    )}
                  </ul>
                </div>

                {pageData.Department.ProductInformation.Compatibility && (
                  <div style={{ height: '10px' }} />
                )}
                {pageData.Department.ProductInformation.Compatibility &&
                  pageData.Department.ProductInformation.Compatibility.length > 0 && (
                    <div>
                      <p className="margin-bottom-10 font-wgt-600 p2-regular">Compatibility</p>
                      {pageData.Department.ProductInformation.Compatibility.map((c, key, ar) => {
                        return (
                          <p
                            key={`Compatibility-${key}`}
                            className={`${
                              key === ar.length - 1 ? 'p2-regular' : 'margin-bottom-20 p2-regular'
                            }`}
                          >
                            {c}
                          </p>
                        );
                      })}
                    </div>
                  )}

                {pageData.Department.ProductInformation.SpecialNote &&
                  pageData.Department.ProductInformation.SpecialNote.length > 0 && (
                    <div>
                      <p className="margin-bottom-10 font-wgt-600 p2-regular margin-top-20">
                        Special Note
                      </p>
                      <ul style={{ paddingInlineStart: '20px' }}>
                        {pageData.Department.ProductInformation.SpecialNote.map((c, key) => {
                          return (
                            <li
                              key={`SpecialNote-${key}`}
                              className="margin-bottom-10"
                              style={{ paddingLeft: '10px' }}
                            >
                              <p className="margin-bottom-20 p2-regular">{c}</p>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}

                {pageData.Department.ProductInformation.Remarks &&
                  pageData.Department.ProductInformation.Remarks.length > 0 && (
                    <div className="margin-top-40">
                      {pageData.Department.ProductInformation.Remarks.map((c, key) => {
                        return (
                          <p
                            key={`Remarks-${key}`}
                            className="margin-bottom-20 p2-small"
                            style={{ fontSize: '13px' }}
                          >
                            {c}
                          </p>
                        );
                      })}
                    </div>
                  )}
              </div>
            </div>
            <div className="col-xs-12 col-sm-3 col-lg-3 product-pricing-content">
              {(!outOfStockPfid?.displayOutOfStock) && (
                <ProductPricingInformation
                  {...props}
                  pricing={getPrices(pageData.Department.PFID, pageData.Department.Sku)}
                  loading={loading}
                  error={fetchError}
                  callback={prodPriceInfoCallBack}
                  outOfStockItems={outOfStockItems}
                />
              )}
              { outOfStockPfid?.displayOutOfStock && (
                <div className="product-unavailable-msg">{outOfStockPfid.outOfStockMessage}</div>
              )}
            </div>
            {((isStockChangeTextAvil({
              pfid: pageData.Department.PFID,
            }) &&
              pageData.Department.DepFooter) ||
              pageData.Department.ProdFooterDesc) && (
              <p className="margin-top-60 margin-bottom-20 dept-footer-text">
                {pageData.Department.DepFooter}
              </p>
            )}
          </div>

          {boughtTogether && (
            <OftenBoughtTogetherPage
              {...props}
              pricing={getPrices(boughtTogether.Department.PFID, boughtTogether.Department.Sku)}
              loading={loading}
              error={fetchError}
              callback={prodPriceInfoCallBack}
              outOfStockItems={outOfStockItems}
            />
          )}

          {pageData.Warning && (
            <div className="row">
              <div className="col-lg-2 col-sm-0 col-xs-0" />
              <div className="col-lg-8 col-sm-12 col-xs-12">
                <div className="margin-top-60 text-align-center">
                  <p style={{ fontSize: '12px' }}>
                    <img className="warning-img" src={WarningImage} alt="Warning" />
                    <span className="font-wgt-500">WARNING: </span> This product can expose you to
                    chemicals including titanium dioxide, which is known to the State of California
                    to cause cancer. For more information go to
                    <a
                      href="https://www.p65warnings.ca.gov/"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-di-id="di-id-3065d40b-371150a"
                    >
                      {' '}
                      www.P65Warnings.ca.gov{' '}
                    </a>
                  </p>
                </div>
              </div>
              <div className="col-lg-2 col-sm-0 col-xs-0" />
            </div>
          )}
        </div>
        {pageData.CheckFacts && <CheckFacts />}
      </div>
      {pageData.HasFaq && (
        <ProductFaq
          FaqDescription={pageData.FaqDescription}
          HasEfileModal={pageData.HasEfileModal}
        />
      )}
      <Modal
        dismissible
        size={modalSize}
        onClose={() => {
          handleModalClose();
        }}
        className={isCheckLock ? 'check-lock-modal' : 'image-modal'}
        open={openModal}
        styleOverrideReason="none"
      >
        <ModalContent overflow={needsOverFlow()} alignment={modalContentAlignment}>
          {modalContent}
        </ModalContent>
      </Modal>
      {pageData.HasEfileModal && (
        <IRSTaxModal open={efileModal} close={closeEfileModal} openModal={openEfileModal} />
      )}
    </div>
  );
};

ProductPage.propTypes = {
  pageData: PropTypes.object.isRequired,
  logToIMWebLogger: PropTypes.func.isRequired,
  logToAnalytics: PropTypes.func.isRequired,
};

export default ProductPage;
